// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AfterSubmitComp-module__wrapper"};